import * as React from 'react'

import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const columns = [
  {
    id: 'firstName',
    attribute: 'firstName',
    name: () => i18n.t('finance.dimension_value_detail.headers.first_name'),
    colSpan: 2,
  },
  {
    id: 'lastName',
    attribute: 'lastName',
    name: () => i18n.t('finance.dimension_value_detail.headers.last_name'),
    colSpan: 3,
  },
  {
    id: 'jobTitle',
    attribute: 'jobTitle',
    name: () => 'Job Title',
    colSpan: 3,
  },
  {
    id: 'dedication',
    attribute: 'dedication',
    name: () => i18n.t('finance.dimension_value_detail.headers.dedication'),
    colSpan: 3,
    isMultipleValue: true,
  },
]

interface Props {
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
  isMultipleValue?: boolean
}

const Header = ({ onSort, attribute, direction, isMultipleValue = false }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        {columns
          .filter((c) => !c.isMultipleValue || isMultipleValue)
          .map((column) => (
            <Table.SortableHeadCell
              key={column.id}
              attribute={column.attribute}
              colSpan={column.colSpan}
              onSort={onSort}
              sortAttribute={attribute}
              sortDirection={direction}
            >
              {column.name()}
            </Table.SortableHeadCell>
          ))}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default Header
